import React, { useState, useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import makeAnimated from "react-select/animated";
import { 
  Link, 
  useHistory, 
  useParams, 
} from "react-router-dom";

import { 
  Radio, 
  RadioGroup, 
  TextField, 
  FormControlLabel,
} from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import Modal from "@material-ui/core/Modal";
import SearchIcon from "@material-ui/icons/Search";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import InfoIcon from "@material-ui/icons/Info";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress"
import Backdrop from "@material-ui/core/Backdrop";

import { apollo_useStyles } from "../../../atom/Apollo_styles";
import {
  estimate_poseidon_segment_path,
  affinitycategorylistposeidon_path,
  affinitycategoryeditposeidon_path,
  apollo_user_path,
  get_poseidon_affinitycategory_path,
  create_poseidon_affinitycategory_path,
  update_poseidon_affinitycategory_path,
  delete_poseidon_affinitycategory_path,
  get_poseidon_condition_path,
  upload_poseidon_file_path,
} from "../../../atom/Apollo_links";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { DeleteButton } from "../../../molecule/Apollo_Button";
import { ApolloRightDrawerContext, RightDrawer } from "../../../molecule/Apollo_RightDrawer";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";

import { 
  Usage, 
  InputType, 
  Operation, 
  EditJSON, 
  Conditions, 
  GroupConditions, 
  ItemConditions,
  GetSegmentCondition,
  POSEIDON_CONDITION,
  POSEIDON_CONDITION_UPDATEDAT,
  UploadFile,
  Status,
} from "./SegmentModel";

import {
  ResGetAffinityCategory,
  initResGetAffinityCategory,
  CreateAffinityCategory,
  UpdateAffinityCategory,
  DeleteAffinityCategory,
  AffinityProcessType,
  AffinityCategory,
} from "./AffinityCategoryModel"
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";

import { Internal1 } from "../../../organism/SEGMENT/SegmentCondition";
import { InformationDrawer } from "../../../organism/SEGMENT/InformationDrawer";

import { 
  ItemList, 
  LogData,
  createLogDate,
  ApolloEventRecord,
  createUserLogItemListFromArray,
  createUserLogItemListFromNumber,
  createUserLogItemListFromString,
} from "../../../atom/Apollo_EventRecord";
import { cloneDeep, toString } from "lodash";
import moment from "moment";

import { GetCoordinateValue } from "./CommonMethod"
import {checkInvalidCharForName} from "../../../common/Apollo_CommonUtil";
import {ErrorMessage} from "@hookform/error-message";

type LogRecord = {
  data: AffinityCategory,
}

const animatedComponents = makeAnimated();

function getModalStyle() {
  return {
      top: `80%`,
      left: `50%`,
      width: `450px`,
      transform: `translate(-50%, -50%)`,
      borderRadius: `10px`,
      background: `#1E434C`,
      lineHeight: `20px`,
  };
};

// @ts-ignore
const ModalEstimate: React.FC<{ uu: number }> = ({ uu }) => {
  let uu1: number = 0;
  if (uu !== null) {
    uu1 = uu;
  }

  return (
    <div style={{fontSize: "20px", color: "white"}}>
      <p>見積結果:</p>
      <p>{uu1.toLocaleString()} アカウント</p>
    </div>
  );
};

// @ts-ignore
const CopyDialog: React.FC<{ affinityCategoryInfo: string, copyAffinityCategory: any }> = ({ affinityCategoryInfo, copyAffinityCategory }) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const title: string = "アフィニティカテゴリコピー";
  const text: string = "このアフィニティカテゴリをコピーしますか？ " + affinityCategoryInfo;

  return (
    <>
      <Button 
        variant="contained"
        onClick={() => {
          handleClickOpen();
        }}
      >
        <FileCopyIcon />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              copyAffinityCategory();
            }}
            color="primary"
            autoFocus
          >
            コピー
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

/*
    画面名：アフィニティカテゴリ作成/編集
 */
const AffinityCategoryEdit: React.FC = () => {
  const classes = apollo_useStyles();
  const history = useHistory();
  const formHooks = useForm<FormData>();
  const { register, handleSubmit, errors, control, formState } = formHooks;
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);
  const processing = useRef(false);

  const {affinityCategoryId, copyAffinityCategoryId} = useParams<{
    affinityCategoryId: string,
    copyAffinityCategoryId: string
  }>();
  
  let breadId: number = (affinityCategoryId === "0") ? 7 : 8;

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: breadId,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // フィルター・除外条件 Component
  const [filterComponent1, setFilterComponent1] = useState([1]);
  const [exceptComponent1, setExceptComponent1] = useState([1]);

  function addFilterComponents() {
    setFilterComponent1(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
  };

  function removeFilterComponents(index: number) {
    setFilterComponent1(current => [...current.filter(i => i !== index)]);
  };

  function addExceptComponents() {
    setExceptComponent1(current => [...current, current.length > 0 ? Math.max(...current) + 1 : 0]);
  };

  function removeExceptComponents(index: number) {
    setExceptComponent1(current => [...current.filter(i => i !== index)]);
  };

  // 【useState】
  const [modalStyle] = useState(getModalStyle);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext); 

  // 編集時ローディング
  const [bdopen, setbdOpen] = React.useState(false);
  
  // affinityCategory
  const [editId, setEditId] = useState("0");
  const [affinityCategories, setAffinityCategory] = useState<ResGetAffinityCategory>(initResGetAffinityCategory);
  const [isEdit, setIsEdit] = useState(false);
  const [checkedDocomoLines, setCheckedDocomoLines] = useState(true);
  const [editFilterAndOr, setEditFilterAndOr] = useState("AND");
  const [editExceptAndOr, setEditExceptAndOr] = useState("AND");
  const [estimateOpen, setEstimateOpen] = useState(false);
  const [uu, setUu] = useState(0);
  const [editUsage, setEditUsage] = useState<Usage>(Usage.Temporary);
  const [editInputType, setEditInputType] = useState<InputType>(InputType.Condition);
  
  const [binary, setBinary] = useState("");
  const [fileName, setFileName] = useState("");
  const [isErrorUpload, setIsErrorUpload] = useState(false);
  const [bucket, setBucket] = useState("");
  const [keyPrefix, setKeyPrefix] = useState("");
  const [region, setRegion] = useState("");

  // 情報
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");

  const [conditionJson, setConditionJson] = useState<EditJSON>();
  const [isAcquiredCondition, setIsAcquiredCondition] = useState(false);

  const beforeEditRecord = useRef<LogRecord | null>(null);

  useEffect(() => {
    const init = async () => {
      bdhandleToggle();

      // セグメント条件取得
      await getAffinityConditionInfo();

      if (affinityCategoryId !== "0" || copyAffinityCategoryId !== undefined) {
        if (affinityCategoryId !== "0") {
          setEditId(affinityCategoryId)
        }
        if (copyAffinityCategoryId !== undefined) {
          setEditId(copyAffinityCategoryId)
        }

        // アフィニティカテゴリ情報取得
        await getAffinityCategoryInfo();
      }

      bdhandleClose();
    }
    init();
  }, []);

  /** セグメント条件取得 */
  const getAffinityConditionInfo = async () => {

    let lsCondition = localStorage.getItem(POSEIDON_CONDITION);
    let lsConditionUpdatedAt = localStorage.getItem(POSEIDON_CONDITION_UPDATEDAT);
    
    let updatedAt1: string = "";
    if (lsCondition != null && lsConditionUpdatedAt != null) {
      updatedAt1 = lsConditionUpdatedAt;
    }

    var request: GetSegmentCondition = {
      updatedAt: updatedAt1,
    };

    const url: string = get_poseidon_condition_path;
    await ApolloAxios.post(url, request).then(response => {
      if (response.data.resultCode < 0) {
        return;
      }

      let result1 = response.data.result;
      localStorage.setItem(POSEIDON_CONDITION, "["+result1.condition+"]");
      localStorage.setItem(POSEIDON_CONDITION_UPDATEDAT, result1.updatedAt);

      setIsAcquiredCondition(true);
    }).catch(err => {
      console.log(err);
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: "セグメント条件のファイルが取得できませんでした。",
        }
      });

      // if (err.redirecturl != "" && err.redirecturl !== undefined) {
      //   const url = err.redirect + history.location.pathname;
      //   history.push( url );
      // }
    });

    if (localStorage.getItem(POSEIDON_CONDITION) !== null) {
      setIsAcquiredCondition(true);
    }
  }

  /** アフィニティカテゴリ情報取得 */
  const getAffinityCategoryInfo = async () => {

    let apiAffinityCategoryId: string = "";
    copyAffinityCategoryId !== undefined ? apiAffinityCategoryId = copyAffinityCategoryId : apiAffinityCategoryId = affinityCategoryId;

    bdhandleToggle();

    let result: any

    // アフィニティカテゴリ情報取得
    let url: string = `${get_poseidon_affinitycategory_path}/${apiAffinityCategoryId}`
    await ApolloAxios.get(url).then(response => {
      result = response.data.result;

      let beforeAffinityData: AffinityCategory = {
        id: 0,
        name: result.name,
        description: result.description === undefined ? "" : result.description,
        uu: 0,
        usage: result.usage,
        inputType: result.inputType,
        condition: "",
        conditionJson: result.conditionJson,
        fileName: result.fileName === undefined ? "" : result.fileName,
        createdAt: "",
        createdBy: 0,
        updatedAt: "",
        updatedBy: 0,
        accountGroupId: 0,
      }

      beforeEditRecord.current = {
        data: cloneDeep(beforeAffinityData),
      }

      setAffinityCategory(result);
      setEditUsage(result.usage);

      // アフィニティカテゴリタイプ
      setEditInputType(result.inputType);

      if (result.inputType === InputType.Condition) {
        const obj = JSON.parse(result.conditionJson);

        setConditionJson(obj);
        setCheckedDocomoLines(obj.spMode);
        setEditFilterAndOr("")
        setEditFilterAndOr(obj.filter.groupOperation);
        setEditExceptAndOr("")
        setEditExceptAndOr(obj.except.groupOperation);

        // フィルター条件
        removeFilterComponents(1);

        let filterGroupConditions = obj.filter.groupConditions;
        if (filterGroupConditions.length > 0) {
          for (let i = 0; i < filterGroupConditions.length; i++) {
            addFilterComponents();
          };
        }

        // 除外条件
        removeExceptComponents(1);
        
        let exceptGroupConditions = obj.except.groupConditions;
        if (exceptGroupConditions.length > 0) {
          for (let i = 0; i < exceptGroupConditions.length; i++) {
            addExceptComponents();
          };
        }
      }

      if (result.inputType === InputType.File && copyAffinityCategoryId === undefined) {
        if (result.fileName === undefined) {
          const warnMsg: string = "ファイルがアップロードされていません。再度ファイルをアップロードしてください。";
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "warning",
              message: warnMsg,
            }
          });
        } else {
          setFileName(result.fileName);
        }
      }

      setIsEdit(true);

      const fetch = async () => {
        // 作成者
        url = `${apollo_user_path}${result.createdBy}`;
        await ApolloAxios.get(url).then(response => {
          let result1 = response.data.result;

          let createdBy1: string = "undefined (ID：" + result.createdBy + ")";
          if (result1.familyName !== undefined) {
            createdBy1 = result1.familyName + " " + result1.firstName;
          }

          setCreatedBy(createdBy1)
        }).catch(err => {
          console.log(err)
        });

        // 更新者
        url = `${apollo_user_path}${result.updatedBy}`;
        await ApolloAxios.get(url).then(response => {
          let result1 = response.data.result;

          let updatedBy1: string = "undefined (ID：" + result.updatedBy + ")";
          if (result1.familyName !== undefined) {
            updatedBy1 = result1.familyName + " " + result1.firstName;
          }

          setUpdatedBy(updatedBy1)
        }).catch(err => {
          console.log(err)
        });
      }
      const fetchAll = async () => {
        await Promise.all(
          [fetch()]
        ).finally(() => {
          console.log("終了");
        })
      }
      fetchAll();

    }).catch(err => {
      const errMsg: string = "アフィニティカテゴリ情報の取得に失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      bdhandleClose();
    });
  }

  // 見積
  const onEstimateSubmit = handleSubmit(async ( data : any ) => {
    if (formState.isSubmitting) return;
    if (processing.current) return;

    let filterConditions = GetCoordinateValue(data, "filter", data.filterAndOr);
    let exceptConditions = GetCoordinateValue(data, "except", data.exceptAndOr);

    let editJSON1: EditJSON = {
      spMode: data.docomoLines,
      filter: filterConditions,
      except: exceptConditions,
    }
    
    let condition = JSON.stringify(editJSON1);

    type Query = {
      condition: string;
    };

    var request: Query = {
      condition: condition,
    };

    bdhandleToggle();
    processing.current = true;

    const url: string = estimate_poseidon_segment_path;
    ApolloAxios.post(url, request).then(response => {
      let resultCode: number = response.data.resultCode;
      if (resultCode < 0 || resultCode === 2) {
        let type1: string = "error";
        if (resultCode === 2) {
          type1 = "info";
        }

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: type1,
            message: response.data.message,
          }
        });
        return;
      }

      setUu(response.data.result);
      setEstimateOpen(true);
    }).catch(err => {
      const errMsg: string = "アフィニティカテゴリの見積に失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      processing.current = false;
      bdhandleClose();
    });
  });

  const onSubmit = handleSubmit(async ( data : any ) => {
    let isSuccess = false;
    if (formState.isSubmitting) return;
    if (processing.current) return;

    if (data.affinityCategoryName === "") {
      const warnMsg: string = "アフィニティカテゴリ名を入力してください。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: warnMsg,
        }
      });

      return;
    }

    let condition: string = "{}";

    if (editInputType === InputType.File) {
      let isError: boolean = false;

      if (affinityCategoryId === "0" && binary === "") {
        isError = true;
      }
      if (affinityCategoryId !== "0" && fileName === "") {
        isError = true;
      }

      if (isError) {
        const warnMsg: string = "ファイルを選択してください。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "warning",
            message: warnMsg,
          }
        });

        return;
      }
    } else {
      let filterConditions = GetCoordinateValue(data, "filter", data.filterAndOr);
      let exceptConditions = GetCoordinateValue(data, "except", data.exceptAndOr);
      
      let editJSON1: EditJSON = {
        spMode: data.docomoLines,
        filter: filterConditions,
        except: exceptConditions,
      }
      
      condition = JSON.stringify(editJSON1);
    }

    // bdhandleToggle();

    let array1: Array<string> = [];

    if (data.usePreference1) {
      array1.push("TARGET")
    }
    if (data.usePreference2) {
      array1.push("EXCEPT")
    }

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    let processType = AffinityProcessType.create;
    if (affinityCategoryId !== "0") {
      processType = AffinityProcessType.edit;
    }

    const editLogInfo = createUserLog(
      state,
      "",
      "アフィニティカテゴリ",
      processType,
      processType === AffinityProcessType.create ? "アフィニティカテゴリ作成" : "アフィニティカテゴリ編集",
      beforeEditRecord.current,
      {
        data: {
          ...cloneDeep(data),
          conditionJson: condition,
          name: data.affinityCategoryName,
          fileName: data.inputType === InputType.Condition ? "" : fileName,
        },
      },
    );
    ApolloEventRecord({...editLogInfo, logType: "execute"});

    let responseId: string = "";
    if (affinityCategoryId === "0") {
      const apiBody: CreateAffinityCategory = {
        name: data.affinityCategoryName,
        description: data.description,
        inputType: data.inputType,
        condition: condition,
        file: binary,
        fileName: fileName,
        createdBy: state.userprofile.userId,
      };

      processing.current = true;
      const url: string = create_poseidon_affinitycategory_path;
      ApolloAxios.post(url, apiBody, {timeout: 60000*3}).then(response => {
        if (response.data.resultCode != 0 && response.data.result !== null) {
          let result = response.data.result;

          const errMsg: string = "ファイルのアップロードに失敗しました。";
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg,
            },
          });

          setBinary("");
          setFileName("");

          setIsErrorUpload(true);
          setBucket(result.bucket);
          setKeyPrefix(result.keyPrefix);
          setRegion(result.region);

          return;
        }

        if (response.data.resultCode < 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: response.data.message,
            },
          });

          return;
        }

        responseId = String(response.data.result);
        isSuccess = true;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: response.data.message,
          },
        });

        history.push(affinitycategorylistposeidon_path);
      }).catch(err => {
        const errMsg: string = "アフィニティカテゴリの作成に失敗しました。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
      }).finally(() => {
        processing.current = false;
        const eventRecords: LogData = {
          ...editLogInfo,
          eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          targetID: responseId,
          targetName: data.affinityCategoryName,
          logType: "result",
          result: isSuccess ? " 成功" : "失敗"
        }
        ApolloEventRecord(eventRecords);

        bdhandleClose();

        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      });

      return;
    }

    responseId = affinityCategoryId;

    const apiBody: UpdateAffinityCategory = {
      id: Number(affinityCategoryId),
      description: checkDiffUpdateString(affinityCategories.description, data.description),
      usage: checkDiffUpdateString(affinityCategories.usage, data.usage),
      inputType: affinityCategories.inputType,
      condition: condition,
      file: binary,
      fileName: fileName,
      updatedBy: state.userprofile.userId,
      expectedVersion: affinityCategories.version,
    };

    processing.current = true;
    const url: string = update_poseidon_affinitycategory_path;
    ApolloAxios.post(url, apiBody, {timeout: 60000*3}).then(response => {
      if (response.data.resultCode != 0 && response.data.result !== null) {
        let result = response.data.result;

        const errMsg: string = "ファイルのアップロードに失敗しました。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          },
        });

        setBinary("");
        setFileName("");

        setIsErrorUpload(true);
        setBucket(result.bucket);
        setKeyPrefix(result.keyPrefix);
        setRegion(result.region);

        return;
      }

      if (response.data.resultCode < 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          },
        });

        return;
      }

      isSuccess = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(affinitycategorylistposeidon_path);
    }).catch(err => {
      const errMsg = `アフィニティカテゴリの更新に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      processing.current = false;
      const eventRecords: LogData = {
        ...editLogInfo,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        targetID: responseId,
        targetName: data.affinityCategoryName,
        logType: "result",
        result: isSuccess ? " 成功" : "失敗"
      }
      ApolloEventRecord(eventRecords);

      bdhandleClose();

      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    });
  });

  // 編集時ローディング
  const bdhandleToggle = () => {
    setbdOpen(!bdopen);
  };

  const bdhandleClose = () => {
      setbdOpen(false);
  };

  // 見積
  const handleEstimateClose = () => {
    setEstimateOpen(false);
  };

  // 情報(Drawer)
  function openInformation() {
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    });
  };

  function closeInformation() {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  };

  // 戻る
  const handelGoback = () => {
    history.push(affinitycategorylistposeidon_path);
  };

  // ファイル選択 変更時
  const fileChange = (e: any) => {
    if (e.target.files !== null) {
      if (e.target.files.length === 0) {
        return;
      }

      const reader = new FileReader();
      setFileName(e.target.files[0].name);

      reader.onload = () => {
        setBinary(reader.result as string);
      }

      reader.readAsText(e.target.files[0]);
    }

    e.target.value = "";
  }

  // ファイル再アップロード
  const fileReUpload = () => {
    if (binary === "") {
      const warnMsg: string = "ファイルを選択してください。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: warnMsg,
        }
      });

      return;
    }

    const apiBody: UploadFile = {
      bucket: bucket,
      keyPrefix: keyPrefix,
      region: region,
      file: binary,
      fileName: fileName,
    };

    const url: string = upload_poseidon_file_path;
    ApolloAxios.post(url, apiBody).then(response => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(affinitycategorylistposeidon_path);
    }).catch(err => {
      const errMsg: string = "ファイルのアップロードに失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    });
  };

  // 削除
  const handleDelete = () => {
    let isSuccess = false;
    let beforeData = beforeEditRecord.current?.data ?? null;
    let targetName = beforeData?.["name"] ?? "";

    const retObj: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "アフィニティカテゴリ編集",
      category: "アフィニティカテゴリ",
      actionType: "削除",
      targetID: affinityCategoryId,
      targetName: targetName,
      itemList: [],
    };
    ApolloEventRecord(retObj);

    if (formState.isSubmitting) return;
    if (processing.current) return;

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    const apiBody: DeleteAffinityCategory = {
      id: Number(affinityCategoryId),
      updatedBy: state.userprofile.userId,
      expectedVersion: affinityCategories.version,
    };

    processing.current = true;
    const url: string = delete_poseidon_affinitycategory_path;
    ApolloAxios.post(url, apiBody).then(response => {
      if (response.data.resultCode < 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          },
        });

        return;
      }

      isSuccess = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(affinitycategorylistposeidon_path);
    }).catch(err => {
      const errMsg = `アフィニティカテゴリの削除に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      processing.current = false;
      const eventRecords: LogData = {
        ...retObj,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess ? " 成功" : "失敗"
      }
      ApolloEventRecord(eventRecords);

      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    });
  };

  // コピーアクション
  function copyAffinityCategory() {
    history.push(`${affinitycategoryeditposeidon_path}0/${affinityCategoryId}`);
    window.location.reload();
  };

  // 更新値差分チェック
  function checkDiffUpdateString(valOld: string, valNew: string) {
    if (valOld === valNew) {
      return "";
    }

    return valNew;
  }

  function checkDiffUpdateNumber(valOld: number, valNew: number) {
    if (valOld === valNew) {
      return 0;
    }

    return valNew;
  }

  function checkDiffUpdateArray(valOld: any, valNew: any) {
    valOld.sort();
    valNew.sort();

    let oldVal: string = valOld.join(",");
    let newVal: string = valNew.join(",");

    if (oldVal === newVal) {
      return [];
    }

    return valNew;
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars />
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>

      <Backdrop className={classes.backdrop} open={bdopen}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form noValidate>
        {editInputType === InputType.Condition && !bdopen ?
          <Tooltip title="見積" placement="top">
            <Fab color="primary" aria-label="edit" className={classes.fab} disabled={processing.current}>
              <Link to="#" className={classes.link} onClick={onEstimateSubmit}>
                <SearchIcon />
              </Link>
            </Fab>
          </Tooltip>
        : ""}
        {affinityCategoryId !== "0" && !bdopen ? 
          <Tooltip title="削除" placement="top">
            <Fab color="primary" aria-label="del" className={classes.fab4} disabled={processing.current}>
              <DeleteButton 
                handleDelete={handleDelete}
                title="アフィニティカテゴリ削除" 
                text={`このアフィニティカテゴリを削除しますか？ ${affinityCategories.name}(ID:${affinityCategoryId})`}
              />
            </Fab>
          </Tooltip>
        : ""}

        {/* 見積ポップアップ */}
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={estimateOpen}
          onClose={handleEstimateClose}>
          <>
          <div 
            style={modalStyle} 
            className={classes.paper}
          >
            <ModalEstimate uu={uu} />
          </div>
          </>
        </Modal>

        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Grid container spacing={3}>
              {affinityCategoryId !== "0" ?
                <Grid 
                  container 
                  justify="flex-end"
                  direction="row"
                  spacing={1}
                >
                  <Grid 
                    item xs={3}
                    alignItems="flex-end"
                    style={{paddingLeft: "130px", paddingTop: "25px"}}
                  >
                    <Tooltip title="コピー" placement="top">
                      <span>
                        <CopyDialog
                          affinityCategoryInfo={`${affinityCategories.name}(ID:${affinityCategoryId})`}
                          copyAffinityCategory={copyAffinityCategory}
                        />
                      </span>
                    </Tooltip>
                    <Tooltip 
                      title="情報" 
                      placement="top" 
                      style={{marginLeft: "10px"}}
                    >
                      <Button 
                        variant="contained"
                        onClick={openInformation}
                      >
                        <InfoIcon />
                      </Button>
                    </Tooltip>
                  </Grid>
                </Grid>
              : ""}

              {/* 情報表示 (Drawer) */}
              {drawerState.open ? 
                <InformationDrawer
                  obj={affinityCategories}
                  closeInformation={closeInformation}
                  typeTitle="カテゴリタイプ"
                  createdBy={createdBy}
                  updatedBy={updatedBy}
                />
              : ""}

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  アフィニティカテゴリ名 ※
                </Typography>
                <Controller
                  name="affinityCategoryName"
                  control={control}
                  components={animatedComponents}
                  key={isEdit ? "Loading" : "Loaded"}
                  defaultValue={copyAffinityCategoryId !== undefined ? affinityCategories.name+"(コピー)" : affinityCategories.name}
                  as={
                    <TextField
                      placeholder="※ 必須入力項目"
                      id="affinityCategoryName"
                      fullWidth
                      disabled={affinityCategoryId !== "0" ? true : false}
                    />
                  }
                  rules={{
                    validate: (e: string) => {
                      const errorMessage = checkInvalidCharForName(e)
                      if(errorMessage) {
                        return errorMessage
                      }},
                  }}
                />
                <ErrorMessage
                    errors={errors}
                    name="affinityCategoryName"
                    as={<Typography variant="caption" className={classes.errorMessage}/>}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  説明
                </Typography>
                <Controller
                  name="description"
                  control={control}
                  key={isEdit ? "Loading" : "Loaded"}
                  defaultValue={affinityCategories.description}
                  as={
                    <TextField
                      id="description"
                      fullWidth
                    />
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  カテゴリタイプ
                </Typography>
                <div style={{display: "flex"}}>
                  <Controller
                    name="inputType"
                    control={control}
                    key={isEdit ? "Loading" : "Loaded"}
                    defaultValue={editInputType}
                    as={
                      <RadioGroup 
                        row 
                        aria-label="position" 
                        name="position1"
                      >
                        <FormControlLabel
                          value={InputType.Condition}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editInputType === InputType.Condition ? true : false}
                              onClick={() => {
                                setEditInputType(InputType.Condition)
                              }}
                              disabled={affinityCategoryId !== "0" ? true : false}
                            />
                          }
                          label="条件指定"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={InputType.File}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editInputType === InputType.File ? true : false}
                              onClick={() => {
                                setEditInputType(InputType.File)
                              }}
                              disabled={affinityCategoryId !== "0" ? true : false}
                            />
                          }
                          label="ファイル"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    }
                  />
                </div>
              </Grid>

              {editInputType === InputType.File ? 
                <Grid item xs={12}>
                  <input
                    id="file1"
                    type="file"
                    accept="text/csv"
                    style={{display: "none"}}
                    onChange={fileChange}
                  />
                  <label htmlFor="file1" style={{marginRight: "10px"}}>
                    <Button 
                      classes={{root: classes.button}} 
                      variant="outlined" 
                      component="span"
                      style={{marginLeft: 120, marginTop: 0}}
                    >
                      ファイルを選択
                    </Button>
                  </label>
                  <label>{fileName}</label>
                </Grid>
              : ""}

              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom component="div">
                  公開ステータス
                </Typography>
                <div 
                  style={{display: "flex"}}
                >
                  <Controller
                    name="usage"
                    control={control}
                    key={editUsage !== Usage.Temporary ? "Loading" : "Loaded"}
                    defaultValue={editUsage}
                    as={
                      <RadioGroup 
                        row 
                        aria-label="position" 
                        name="position1"
                      >
                        <FormControlLabel
                          value={Usage.Production}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editUsage === Usage.Production ? true : false}
                              onClick={() => {
                                setEditUsage(Usage.Production)
                              }}
                              disabled={affinityCategoryId === "0" ? true : false}
                            />
                          }
                          label="公開"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={Usage.Temporary}
                          control={
                            <Radio 
                              color="primary" 
                              checked={editUsage === Usage.Temporary ? true : false}
                              onClick={() => {
                                setEditUsage(Usage.Temporary)
                              }}
                              disabled={affinityCategoryId === "0" ? true : false}
                            />
                          }
                          label="非公開"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    }
                  />
                </div>
              </Grid>
            </Grid>
          </CardContent>
            
          {editInputType === InputType.Condition && isAcquiredCondition ? 
            <CardContent>
              <div style={{
                background: "white", 
                padding: "15px", 
                borderRadius: "10px"
              }}>
                <Grid 
                  container 
                  spacing={1} 
                  justify="space-between" 
                  alignItems="center"
                  direction="row"
                >
                  <Grid item xs={6}>
                    <div style={{display: "flex"}}>
                      <p style={{marginRight: "8px"}}>グループ間結合条件</p>
                      <Controller
                        name="filterAndOr"
                        control={control}
                        key={editFilterAndOr ? "Loading" : "Loaded"}
                        defaultValue={editFilterAndOr}
                        as={
                          <RadioGroup 
                            row 
                            aria-label="position" 
                            name="filter-position1"
                          >
                            <FormControlLabel
                              value={Operation.And}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editFilterAndOr === Operation.And ? true : false}
                                  onClick={() => {
                                    setEditFilterAndOr(Operation.And)
                                  }}
                                />
                              }
                              label={Operation.And}
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value={Operation.Or}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editFilterAndOr === Operation.Or ? true : false}
                                  onClick={() => {
                                    setEditFilterAndOr(Operation.Or)
                                  }}
                                />
                              }
                              label={Operation.Or}
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <Controller
                      name="docomoLines"
                      control={control}
                      defaultValue={checkedDocomoLines}
                      key={checkedDocomoLines ? "Loading" : "Loaded"}
                      as={
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={checkedDocomoLines}
                              onChange={e => {
                                setCheckedDocomoLines(e.target.checked);
                              }}
                            />
                          }
                          label={<span style={{fontSize: "18px"}}>docomo回線契約者のみ</span>}
                        />
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    {
                      filterComponent1 ?
                      filterComponent1.map((cmp1: string | number | null | undefined, index: number) =>
                        <Internal1 
                          key={`filter-${cmp1}`}
                          removeComponents={removeFilterComponents}
                          cmp1={cmp1}
                          control={control}
                          condition={conditionJson?.filter.groupConditions[index]}
                          type="filter"
                          editId={editId}
                          bdopen={bdopen}
                        />
                      )
                      : ""
                    }
                    <Tooltip title="条件グループを追加" placement="top">
                      <Fab color="primary" aria-label="add" size="small" style={{marginLeft: "-10px", marginTop: "-10px"}}>
                        <Link to="#" onClick={addFilterComponents} className={classes.link}>
                          <AddIcon/>
                        </Link>
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>
              </div>

              {/* 除外 */}
              <div style={{
                background: "#FFCCBB", 
                padding: "15px", 
                borderRadius: "10px"
              }}>
                <Grid 
                  container 
                  spacing={1} 
                  justify="space-between" 
                  alignItems="center"
                  direction="row"
                >
                  <Grid item xs={6}>
                    <div style={{display: "flex"}}>
                      <h3 style={{marginTop: "15px", marginRight: "8px"}}>除外条件</h3>
                      <p style={{marginRight: "8px", marginTop: "17px", width: "127px"}}>グループ間結合条件</p>
                      <Controller
                        name="exceptAndOr"
                        control={control}
                        key={editExceptAndOr ? "Loading" : "Loaded"}
                        defaultValue={editExceptAndOr}
                        as={
                          <RadioGroup 
                            row 
                            aria-label="except-position" 
                            name="except-position1"
                          >
                            <FormControlLabel
                              value={Operation.And}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editExceptAndOr === Operation.And ? true : false}
                                  onClick={() => {
                                    setEditExceptAndOr(Operation.And)
                                  }}
                                />
                              }
                              label={Operation.And}
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value={Operation.Or}
                              control={
                                <Radio 
                                  color="primary"
                                  checked={editExceptAndOr === Operation.Or ? true : false}
                                  onClick={() => {
                                    setEditExceptAndOr(Operation.Or)
                                  }}
                                />
                              }
                              label={Operation.Or}
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        }
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    {
                      exceptComponent1 ?
                      exceptComponent1.map((cmp1: string | number | null | undefined, index: number) =>
                        <Internal1 
                          key={`except-${cmp1}`}
                          removeComponents={removeExceptComponents}
                          cmp1={cmp1}
                          control={control}
                          condition={conditionJson?.except.groupConditions[index]}
                          type="except"
                          editId={editId}
                          bdopen={bdopen}
                        />
                      )
                      : ""
                    }
                    <Tooltip title="除外条件グループを追加" placement="top">
                      <Fab color="primary" aria-label="add" size="small" style={{marginLeft: "-10px", marginTop: "-10px"}}>
                        <Link to="#" onClick={addExceptComponents} className={classes.link}>
                          <AddIcon/>
                        </Link>
                      </Fab>
                    </Tooltip>
                  </Grid>
                </Grid>
              </div>
            </CardContent>
          : ""}
          
          <CardActions className={classes.cardaction}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              onClick={onSubmit}
              disabled={
                isErrorUpload || 
                processing.current ||
                (affinityCategoryId !== "0" && 
                  (affinityCategories.status === Status.Processing || 
                    affinityCategories.status === Status.Validating)) ? true : false}

              className={classes.button}
            >
              {affinityCategoryId === "0" ? "作成" : "更新"}
            </Button>
            {isErrorUpload ? 
              <Button
                variant="contained"
                color="primary"
                onClick={fileReUpload}
                className={classes.button}
              >
                ファイル再アップロード
              </Button>
            : ""}
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
              disabled={processing.current}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </form>
    </GenericTemplate>
  );
};

const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
) => {
  const beforeData = beforeInfo?.data ?? null;
  const afterData = afterInfo?.data;

  const items: ItemList[] = [
    createUserLogItemListFromString("アフィニティカテゴリ名", "name", beforeData, afterData),
    createUserLogItemListFromString("説明", "description", beforeData, afterData),
    createUserLogItemListFromString("カテゴリタイプ", "inputType", beforeData, afterData),
    createUserLogItemListFromString("公開ステータス", "usage", beforeData, afterData),
    createUserLogItemListFromString("ファイル名", "fileName", beforeData, afterData),
    createUserLogItemListFromString("セグメント条件", "conditionJson", beforeData, afterData),
  ];

  const retObj = createLogDate(
      apolloContex,
      menu,
      category,
      actionType === AffinityProcessType.create ? "作成" : "更新",
      displayName,
      items,
  )

  return retObj
};

export default AffinityCategoryEdit;
